import React from 'react';
import '@/utils/legacyColor.css';

interface NotificationBannerProps {
  icon: string;
  message: string;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  icon,
  message,
}) => {
  return (
    <div
      style={{
        margin: '10px 0px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'var(--zl-banner-info-bg, var(--light-blue))',
        color: 'white',
        padding: '12px 16px',
        borderRadius: '12px',
        width: '100%',
      }}
    >
      <img
        src={icon}
        alt='Info'
        style={{
          width: '20px',
          height: '20px',
          marginRight: '8px',
        }}
      />

      <span style={{ fontSize: '12px' }}>{message}</span>
    </div>
  );
};

export default NotificationBanner;
